import { render, staticRenderFns } from "./JudicialProcessDrawer.vue?vue&type=template&id=4699475e"
import script from "./JudicialProcessDrawer.vue?vue&type=script&lang=js"
export * from "./JudicialProcessDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports